import { ApiConstant } from "const";
import { createApiWithToken } from "services/config/api.config";

export const getReportByType = data =>
  createApiWithToken().get(ApiConstant.GET_STATISTICS, data, { responseType: data.export_f === 1 ? "blob" : "json" });
